/**
 * OPAC 予約数取得 API サービス
 *
 * バックエンド /api/library-stats/batch を叩く薄いラッパー。
 */

import { apiClient } from '@/api/client'
import type { LibraryStatsItem, LibraryStatsResult } from '@/api/types/library-stats'

/**
 * 複数 URL に対して並列に統計を取得する。
 * 個別の失敗は結果配列の status に反映され、全体は 200 で返る。
 */
export const fetchLibraryStatsBatch = async (items: LibraryStatsItem[]): Promise<LibraryStatsResult[]> => {
  if (items.length === 0) return []
  const res = await apiClient.post<LibraryStatsResult[]>('/library-stats/batch', { items })
  return res.data
}
